import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-shell',
  templateUrl: './page-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageShellComponent {
  @Input() title = '';
  @Input() description?: string;
  @Input() icon?: string;
  @Input() shellClass = '';
  @Input() headerClass = 'mb-[30px]';

  protected hasHeader(): boolean {
    return Boolean(this.title || this.description || this.icon);
  }
}
